import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-pixel-mining',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './pixel-mining.component.html',
  styleUrl: './pixel-mining.component.scss'
})
export class PixelMiningComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.pixelMining;
}
